module.exports = __webpack_public_path__ + "img/svg_check.6cf23bfe.svg";